
const host_state = (require('../../build/status')).status  //true为正式，false为测试

// 测试接口
let host = 'http://security-api.52shanglu.com/';
// let host = 'https://shopingapi.guogekeji.com';
let uploadUrl = 'https://changqin-advertisement.oss-cn-zhangjiakou.aliyuncs.com'

if(host_state){
    // 正式接口
    host = 'https://cq-security-api.changqinos.com';
}

export default {
    host,
    uploadUrl,
    host_state
}